import { i18n } from "@lingui/core";
//#region src/i18n/effects.ts
const activateLocaleMessages = (localeId, messages) => {
	if (i18n.locale !== localeId) i18n.loadAndActivate({
		locale: localeId,
		messages
	});
};
//#endregion
export { activateLocaleMessages };

//# sourceMappingURL=effects.js.map